import { GroupedListData } from 'modules/analytics/common/types';
import { sumScoreField } from 'modules/analytics/common/utils';
import { satisfactionScore } from 'modules/analytics/survey/utils/survey-scores';
import SurveyRateCell from 'modules/survey/management/components/SurveyRateCell/SurveyRateCell';

const SatisfactionScoreCell = ({ data }: { data: GroupedListData }) => {
  const positivesTotal = data.isGroup ? sumScoreField(data?.scoreData || [], 'positivesTotal') : data.positivesTotal;
  const total = data.isGroup ? sumScoreField(data?.scoreData || [], 'total') : data.total;

  return <SurveyRateCell key={data._id} number={satisfactionScore(positivesTotal || 0, total || 0)} />;
};

export default SatisfactionScoreCell;
